:host {
  display: block;
  position: relative;
  width: 100%;
  &[data-modal-trigger] {
    cursor: pointer;
  }
}

:host(.--is-full-height) {
  height: 100%;
}

.spw-card {
  display: block;
  border-radius: 5px;
  background: var(--spw-ds-white);
  box-shadow: var(--spw-effect-elevation-2);
  transition: all 0.3s ease-in-out;

  :host(.--is-full-height) & {
    height: 100%;
  }

  &--hoverable:hover {
    box-shadow: var(--spw-effect-elevation-4);
    transform: translateY(-5px);
  }
}

.spw-card__link {
  display: block;
  height: 100%;
  width: 100%;
  color: inherit;
  text-decoration: none;

  .spw-card--no-image & {
    padding-top: 15px;
  }

  &:focus-visible {
    outline: 3px solid var(--spw-ds-focus);
    outline-offset: 2px;
    border-radius: 5px;
  }
}
